import { Context } from '@nuxt/types';
import { useAuth } from '@/plugins/auth';

export default async function ({ route, redirect }: Context): Promise<void> {
  const { user } = useAuth();

  if (
    user.organization.config?.shojihomuKommentarOnly &&
    // 文献以外閲覧不可能
    !route.path.startsWith('/document/')
  ) {
    redirect(302, '/document/kommentar_shojihomu_kaishaho_1');
  }
}
